import { GlycerinAvailability } from '@packages/tracking/src/types/enums';
import type { RawProductQuery } from '@packages/gql/generated/shopping/graphql';

/* GraphQL */ `
  fragment GetGlycerinAvailabilityFragment on Availability {
    message
    state
  }
`;

export type GetGlycerinAvailabilityProps = Pick<
  NonNullable<RawProductQuery['product']>['availability'],
  'state' | 'message'
>;

export const getGlycerinAvailability = (availability: GetGlycerinAvailabilityProps) => {
  const { state, message } = availability;

  // set the default to UNKNOWN
  const glycerinAvailability: {
    availability: GlycerinAvailability;
    estimatedDelivery: string | undefined;
  } = {
    availability: GlycerinAvailability.UNKNOWN,
    estimatedDelivery: undefined,
  };

  // check state and return correct mapping
  switch (state) {
    case 'AVAILABLE':
      glycerinAvailability.availability = GlycerinAvailability.IMMEDIATELY;
      glycerinAvailability.estimatedDelivery = message;
      return glycerinAvailability;
    case 'NOT_YET_AVAILABLE':
      glycerinAvailability.availability = GlycerinAvailability.NOTIMMEDIATELY;
      glycerinAvailability.estimatedDelivery = message;
      return glycerinAvailability;
    case 'NOT_AVAILABLE':
      glycerinAvailability.availability = GlycerinAvailability.UNAVAILABLE;
      glycerinAvailability.estimatedDelivery = undefined;
      return glycerinAvailability;
    case 'UNSELECTED':
    default:
      return glycerinAvailability;
  }
};
